exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.daterangepicker-custom{\n  padding-top: 4px;\n  width: 300px;\n}\n", ""]);

// exports
